var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_43017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38999 8.38852L5.59375 5.59229",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8699 12.5159C10.6514 12.7344 10.3551 12.8572 10.0461 12.8573C9.73705 12.8573 9.44068 12.7346 9.22213 12.5162C9.00359 12.2977 8.88079 12.0014 8.88073 11.6923C8.88068 11.3833 9.00338 11.087 9.22184 10.8684L8.19248 11.8984C7.97393 12.1169 7.67753 12.2397 7.36846 12.2397C7.05939 12.2397 6.76299 12.1169 6.54444 11.8984C6.3259 11.6798 6.20312 11.3834 6.20312 11.0743C6.20312 10.7653 6.3259 10.4689 6.54444 10.2503L10.2518 6.54298C10.4703 6.32444 10.7667 6.20166 11.0758 6.20166C11.3849 6.20166 11.6813 6.32444 11.8998 6.54298C12.1184 6.76152 12.2411 7.05793 12.2411 7.367C12.2411 7.67606 12.1184 7.97247 11.8998 8.19101L10.8699 9.22038C11.0884 9.00191 11.3848 8.87921 11.6938 8.87927C12.0028 8.87932 12.2992 9.00213 12.5176 9.22067C12.7361 9.43921 12.8588 9.73559 12.8587 10.0446C12.8587 10.3536 12.7359 10.6499 12.5173 10.8684L10.8699 12.5159Z",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5265 12.525L11.7109 11.7095",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2726 2.27211L1.45703 1.45654",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73194 7.43782C3.5134 7.65637 3.21699 7.77914 2.90792 7.77914C2.59886 7.77914 2.30245 7.65637 2.08391 7.43782C1.86536 7.21928 1.74259 6.92287 1.74259 6.61381C1.74259 6.30474 1.86536 6.00833 2.08391 5.78979L3.11386 4.76042C3.00564 4.8686 2.87719 4.9544 2.73582 5.01293C2.59445 5.07145 2.44293 5.10156 2.28992 5.10154C1.98091 5.10148 1.68458 4.97868 1.46611 4.76013C1.35794 4.65192 1.27214 4.52346 1.21361 4.38209C1.15508 4.24072 1.12497 4.08921 1.125 3.9362C1.12505 3.62719 1.24786 3.33086 1.4664 3.11239L3.11386 1.46494C3.33232 1.2464 3.62865 1.12359 3.93767 1.12354C4.09067 1.12351 4.24219 1.15362 4.38356 1.21215C4.52493 1.27067 4.65339 1.35647 4.7616 1.46465C4.86981 1.57282 4.95566 1.70125 5.01423 1.8426C5.07281 1.98395 5.10298 2.13545 5.103 2.28846C5.10303 2.44147 5.07292 2.59298 5.01439 2.73435C4.95586 2.87572 4.87006 3.00418 4.76189 3.11239L5.79126 2.08244C6.0098 1.8639 6.30621 1.74112 6.61527 1.74112C6.92434 1.74112 7.22075 1.8639 7.43929 2.08244C7.65783 2.30099 7.78061 2.59739 7.78061 2.90646C7.78061 3.21553 7.65783 3.51193 7.43929 3.73048L3.73194 7.43782Z",
    stroke: "#364153",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_43017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9812,
    height: 13.9812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.e5a1d9a7827df1966e047e3e09b49919.svg";
export { ForwardRef as ReactComponent };